type Props = {
  setQuery: (a: string) => void
}

export const Search = ({ setQuery }: Props) => {
  return (
    <div className="mt-3 mb-1 rounded-lg border border-solid border-[#BFC1C3] flex flex-row w-full overflow-hidden">
      <div className="w-[calc(100%-54px)]">
        <input
          type="text"
          className="w-full h-full px-4 py-[15px] text-[#232323] text-sm tracking-[-0.42px] font-normal placeholder:italic placeholder:font-[325] placeholder:text-[#666] focus:outline-none"
          name="search-brand"
          placeholder="Digita il nome del Brand"
          pattern="[^A-Za-z0-9]+"
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>
    </div>
  )
}
